import { z } from 'zod';

export const referralsSearchSchema = z.object({
  /**
   * Id of the referral whose detail sheet is open. Present iff the sheet is
   * open, so the URL always describes what is on screen and a specific
   * referral can be linked to, reloaded, or pasted to someone else.
   *
   * It is the TASK id — a referral row is a referral-labeled task — which is
   * also what `/tasks/$taskId` and the task API take, so the same id works
   * across surfaces.
   *
   * `.uuid()` is validated at the URL boundary: a hand-edited
   * `?referral=banana` is rejected by the router instead of flowing into a
   * by-id fetch that 404s behind a spinner.
   */
  referral: z.string().uuid().optional(),
  /**
   * Interaction whose Call detail sheet is open, on top of the referral.
   * Written by `useCallDetailParam`; must be declared here or the router
   * strips it. See that hook for why it is route-agnostic.
   */
  call: z.string().uuid().optional(),
});

export type ReferralsSearch = z.infer<typeof referralsSearchSchema>;
